import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import CardHeader from "@material-ui/core/CardHeader";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import CardMedia from "@material-ui/core/CardMedia";
import FavoriteIcon from "@material-ui/icons/Favorite";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 300,
    borderRadius: 20,
    boxShadow: `rgba(17, 70, 93, 0.5) 0px 2px 8px !important `,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    fontSize: 20,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      color: "white",
    },
  },
  media: {
    padding: 0,
    height: 300,
  },
  favorite: {
    color: "#70adb5",
  },
}));

function SimpleCard(props) {
  const [getLearn, setLearnMore] = useState(false);
  const [getLike, setLike] = useState(false);

  function LearnMore() {
    setLearnMore(!getLearn);
  }

  function IsLike() {
    console.log("da like");
    setLike(!getLike);
  }

  const classes = useStyles(props);

  return (
    <Grid item container md={3} xs={12}>
      <Card className={classes.root}>
        <CardContent style={{ padding: "0" }}>
          <CardMedia className={classes.media} image={props.media} />
          <CardContent style={{ padding: "10px" }}>
            <Typography className={classes.pos}>{props.name}</Typography>
          </CardContent>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default SimpleCard;
